<template>
  <div>
    <title-block id="bm0" v-if="titles[0].num">
      <template slot="title">{{titles[0].label}}</template>
      <div class="mt-10">
        <div class="newsCard mb-10" v-for="(item,i) in news" :key="i">
          <a class="h4" :href="item.uri" target="about" style="font-weight: bold;">{{item.title}}</a>
          <div class="message">
            <div class="mr-10"><a rel="noopener noreferrer" :href="item.uri" target="about">{{item.website}}</a></div>
            <div class="mr-10"><span>{{item.rtm | getTimeDescribe}}</span></div>
            <div><a rel="noopener noreferrer" :href="item.uri" target="about" style="color: #409EFF;">查看原文</a></div>
          </div>
          <p v-html="item.abstracts"></p>
          <!-- <div class="about">相关：<span>{{item.companyName}}</span></div> -->
        </div>
        <pagination :pageNum="pageNum" :total="total" @currentChange="handleCurrentChange" />
      </div>
    </title-block>
  </div>
</template>

<script>
import titleBlock from './titleBarBlock'
import Pagination from '@/components/paginationSimple'
import { getNews } from '../api/newClueApi'

export default {
  name: '',
  components: {
    titleBlock,
    Pagination
  },
  props: {
    info: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    return {
      titles: [
        { type: '', label: '新闻动态', num: 0 },
      ],
      news: [],
      pageNum: 1,
      total: 0
    }
  },
  mounted() {
    this.$emit('setTitle', this.titles)
    this.getNews()
    // this.keyMan()
    // this.changeInfo()
  },
  filters: {
    getTimeDescribe(val) {
      const nowTime = Date.parse(new Date()) //当前时间戳
      const year = (nowTime - val) / (12 * 30 * 24 * 60 * 60 * 1000)
      if (year > 1) return Math.floor(year) + '年前'
      const month = (nowTime - val) / (30 * 24 * 60 * 60 * 1000)
      if (month > 1) return Math.floor(month) + '月前'
      const day = (nowTime - val) / (24 * 60 * 60 * 1000)
      if (day > 1) return Math.floor(day) + '天前'
      const hour = (nowTime - val) / (60 * 60 * 1000)
      if (hour > 1) return Math.floor(hour) + '小时前'
      const min = (nowTime - val) / (60 * 1000)
      if (min > 1) return Math.floor(min) + '分钟前'
    },
  },
  computed: {
  },
  methods: {
    async getNews(init) {
      this.waiting = true
      this.news = []
      let name = null
      if(this.$parent && this.$parent.companyStatus){
        name = this.$parent.companyStatus.companyName
      } else if(this.$parent.$parent && this.$parent.$parent.companyStatus){
        name = this.$parent.$parent.companyStatus.companyName
      } else if(this.$parent.$parent.$parent && this.$parent.$parent.$parent.companyStatus){
        name = this.$parent.$parent.$parent.companyStatus.companyName
      } else if(this.$parent.$parent.$parent.$parent && this.$parent.$parent.$parent.$parent.companyStatus){
        name = this.$parent.$parent.$parent.$parent.companyStatus.companyName
      }


      const { data } = await getNews({
        name: name,
        pageNum: this.pageNum,
        pageSize: 10
      })
      if (data) {
        this.news = data.items
        this.total = data.total
        this.titles[0].num = data.total
      } else { }
    },
    handleCurrentChange(val) {
      this.pageNum = val
      this.getNews()
    }
  }
}
</script>

<style scoped lang="scss">
.newsCard {
  // box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  border: 1px solid #f2f2f2;
  padding: 20px;

  .h4 {
    color: #333;
  }
  p {
    margin-top: 10px;
    font-size: 12px;
  }
  .message {
    display: flex;
    // justify-content: space-between;
    > div {
      color: #aaa;
      font-size: 12px;
      > span {
        font-size: 12px;
      }
    }
  }
  .about {
    font-size: 12px;
    > span {
      font-size: 12px;
      color: #507afb;
    }
  }
}
</style>
